import axs from 'axios'
import store from '../store'
import router from '../router'

const request = axs.create({
  baseURL: '/api', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 40000, // request timeout,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

request.interceptors.request.use(
  config => {
    // do something before request is sent
    if (store.getters.token && !config['withNoToken']) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Authorization'] = store.getters.token
    }
    config.headers['language'] = store.getters.locale
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
request.interceptors.response.use(
  response => {
    if (response.status === 200) {
      if (!response.data.success) {
        const code = response.data.code
        // 未绑定谷歌验证码
        if (code && code === 'GOOGLE_NOT_YET_BIND') {
        }
        // 未绑定资金密码
        if (code && code === 'USER_FUND_PASSWORD_NOT_YET_BIND') {
        }
      }
      // response.data['forceLogout'] = true
      // response.data['message'] = '登录状态一变化, 请重新登录'
      // 强制登出
      if (response.data['forceLogout']) {
        store.dispatch('logout')
          .then(() => {
            router.replace('/login')
          })
      }
      try {
        return JSON.parse(response.data)
      } catch (e) {
        return response.data
      }
    }
  },
  error => {
    console.log('request error = ' + error) // for debug
    return Promise.reject(error)
  }
)

export function getJsonp (url, data) {
  if (!url) { throw new Error('url is necessary') }
  const callback = 'CALLBACK' + Math.random().toString().substr(9, 18)
  const JSONP = document.createElement('script')
  JSONP.setAttribute('type', 'text/javascript')

  const headEle = document.getElementsByTagName('head')[0]

  let ret = ''
  if (data) {
    if (typeof data === 'string') { ret = '&' + data } else if (typeof data === 'object') {
      for (let key in data) { ret += '&' + key + '=' + encodeURIComponent(data[key]) }
    }
    ret += '&_time=' + Date.now()
  }
  JSONP.src = `${url}?callback=${callback}${ret}`
  return new Promise((resolve, reject) => {
    window[callback] = r => {
      resolve(r)
      headEle.removeChild(JSONP)
      delete window[callback]
    }
    headEle.appendChild(JSONP)
  })
}

export default request




// WEBPACK FOOTER //
// ./src/utils/request.js